export default `# Apply layout must be specified:
[[layout]]
name = "apply"

[[layout.group]]
name = "applicant"
title = "Replace me"
description = "Property details and requirements." # optional
questions = [
  ["date_of_birth", "applicant"]
]

# Uncomment to use:
[[question]]
name = ["date_of_birth", "applicant"] # must be specified in questions
title = "What is your date of birth?"
required = true
`;
